import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "./redux.js";
import { useAppQuery } from "./index.js";
import { SELECT_PRODUCTS_BASED_ON_ALL } from "../../constants/selectProductsBasedOn.js";
import { OPEN_MODAL_UPSELL } from "../constants/modalTypes.js";
import { openModal } from "../store/features/modal.js";

interface IAction {
    id: string;
    name: string;
    selectedProducts: {
        stockSelectedProducts: {
            selectProductsBasedOn: string;
            selectedSpecificItems: any[];
        };
    };
}

interface IActions {
    actions: IAction[]
}

const emptyPlan = {
    id: "-1",
    name: "",
    productsLimit: 0,
    collectionsLimit: 0,
    monthlyPrice: 0,
    yearlyPricePerMo: 0,
    crossedPrice: 0,
    createdAt: new Date(),
    updatedAt: new Date(),
};

export const useRejectedActions = () => {
    const dispatch = useAppDispatch();
    const shop = useAppSelector((state) => state.shop.data);
    const currentPlan = shop.subscriptionPlan ?? emptyPlan;

    const { isLoading, data, refetch } = useAppQuery<IActions, Error>({
        url: "/api/action/rejected",
        reactQueryOptions: {},
        fetchInit: {}
    });

    useEffect(() => {
        if (data && data.actions) {
            const actions = data.actions;
            const actionCounts = actions.map((action) => {
                const selectProductsBasedOn = action?.selectedProducts?.stockSelectedProducts?.selectProductsBasedOn;
                if (selectProductsBasedOn === SELECT_PRODUCTS_BASED_ON_ALL) {
                    return {
                        productsCount: shop?.productsCount ?? 0,
                        colectionsCount: 0,
                    };
                } else {
                    const items = action?.selectedProducts?.stockSelectedProducts?.selectedSpecificItems ?? [];
                    const collections = items.filter(({ type }) => type === "collection");
                    const products = items.filter(({ type }) => type !== "collection");
                    const allProductsCount = collections.reduce((sum: number, collection) => sum + collection.productsCount, 0) + products.length;
                    return {
                        productsCount: allProductsCount ?? 0,
                        colectionsCount: collections?.length ?? 0,
                    };
                }
            });
            const maxCollectionCount = actionCounts.reduce((max, obj) => obj.colectionsCount > max ? obj.colectionsCount : max, 0);
            const maxProductCount = actionCounts.reduce((max, obj) => obj.productsCount > max ? obj.productsCount : max, 0);

            if (maxProductCount > currentPlan.productsLimit || maxCollectionCount > currentPlan.collectionsLimit) {
                dispatch(openModal({
                    modalType: OPEN_MODAL_UPSELL,
                    modalData: {
                        limitProductCount: maxProductCount,
                        limitCollectionCount: maxCollectionCount,
                    },
                }));
            }
        }
    }, [data, currentPlan, dispatch, shop?.productsCount]);

    return { isLoading, actions: data?.actions ?? [], refetch };
};